import React, { createContext, useMemo } from 'react';
export var ErrorMonitorContext = createContext(null);
export var ErrorMonitorConsumer = ErrorMonitorContext.Consumer;
export var ErrorMonitorProvider = function (_a) {
    var errorMonitor = _a.errorMonitor, children = _a.children;
    var value = useMemo(function () { return ({ errorMonitor: errorMonitor }); }, [errorMonitor]);
    return (React.createElement(ErrorMonitorContext.Provider, { value: value.errorMonitor, children: children }));
};
//# sourceMappingURL=ErrorMonitorProvider.js.map